import { useRecoilValue } from 'recoil';
import { sortedCoverablesListSelector } from '../recoil/selectors/sortedCoverablesListSelector';
import { externalCasesAtom } from '../recoil/atoms/externalCasesAtom';
import { isAnyEdiCancellationCasePending } from '../utils/externalCasesUtil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { fetchedPaymentInformationAtom } from '../recoil/atoms/fetchedPaymentInformationAtom';
import { PAYMENT_PLAN } from '../constants/paymentMethods';

export const useGetMpsActivationRule = (): boolean => {
    const externalCases = useRecoilValue(externalCasesAtom);
    const { sortedCoverables, sortedRemovedCoverables } = useRecoilValue(
        sortedCoverablesListSelector
    );
    const allCoverablesDTO = sortedCoverables.concat(sortedRemovedCoverables);
    const areAllCoverablesSpunOff = allCoverablesDTO.every((cov) => cov.willSpinOff);
    const { isPolicyChange } = useRecoilValue(jobInfoAtom);
    const { paymentMethod } = useRecoilValue(fetchedPaymentInformationAtom);
    return (
        !isAnyEdiCancellationCasePending(externalCases) &&
        !areAllCoverablesSpunOff &&
        !isPolicyChange &&
        paymentMethod === PAYMENT_PLAN.MPS
    );
};
